__turbopack_context__.v({
  "btnBigBlue": "components-module__W_1XrG__btnBigBlue",
  "btnSmall": "components-module__W_1XrG__btnSmall",
});
